
import React, { useState } from 'react';
import { ChevronDown } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const Accordion = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className={`accordion ${isOpen ? "open" : ""}`}>
            <button className="accordion-trigger" onClick={() => setIsOpen(!isOpen)}>
                <h3>{title}</h3>
                <ChevronDown className={`accordion-icon ${isOpen ? "rotated" : ""}`} />
            </button>
            {isOpen && <>{children}</>}
        </div>
    );
};

const AcceptButton = ({ projectName }) => {
    const [status, setStatus] = React.useState('idle');

    const handleAccept = async () => {
        setStatus('loading');
        try {
            const res = await fetch('/api/quoteAccept', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ quoteId: 'JsusA8ulIfJ9', projectName })
            });
            const data = await res.json();
            setStatus(data.ok ? 'done' : 'error');
        } catch {
            setStatus('error');
        }
    };

    if (status === 'done') return <div className="accept-confirm">✓ Got it! I'll be in touch soon.</div>;
    if (status === 'error') return <div className="accept-error">Something went wrong — just shoot me a text.</div>;
    return (
        <button className="accept-button" onClick={handleAccept} disabled={status === 'loading'}>
            {status === 'loading' ? 'Sending...' : 'Accept This Quote'}
        </button>
    );
};

function Quote_JsusA8ulIfJ9() {
    const navigate = useNavigate();
    const [input, setInput] = React.useState('');
    const [unlocked, setUnlocked] = React.useState(false);
    const [error, setError] = React.useState('');

    const unlock = () => {
        setUnlocked(true);
        fetch('/api/quoteRoute/viewed', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ quoteId: 'JsusA8ulIfJ9' })
        }).catch(() => {});
    };

    if (!unlocked) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9fafb' }}>
                <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '2rem', width: '100%', maxWidth: '380px', textAlign: 'center' }}>
                    <img src='/transparent-logo-min.png' alt='Logo' style={{ width: '100%', marginBottom: '1rem' }} />
                    <h2 style={{ marginBottom: '0.25rem' }}>Your Quote</h2>
                    <p style={{ color: '#6b7280', marginBottom: '1.5rem', fontSize: '0.9rem' }}>North Florida Home Repair & Maintenance</p>
                    <input
                        type="text"
                        placeholder="Enter your phone number"
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                const cleaned = input.replace(/\D/g, '') || input.trim();
                                if (cleaned === '9049168728') {
                                    unlock();
                                } else {
                                    setError('Incorrect. Try again.');
                                }
                            }
                        }}
                        style={{ padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.95rem', width: '100%', boxSizing: 'border-box', marginBottom: '0.5rem' }}
                    />
                    {error && <p style={{ color: '#ef4444', fontSize: '0.875rem', margin: '0 0 0.5rem' }}>{error}</p>}
                    <button
                        onClick={() => {
                            const cleaned = input.replace(/\D/g, '') || input.trim();
                            if (cleaned === '9049168728') {
                                unlock();
                            } else {
                                setError('Incorrect. Try again.');
                            }
                        }}
                        style={{ background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.65rem 1.25rem', fontSize: '0.95rem', cursor: 'pointer', width: '100%' }}
                    >
                        View quote
                    </button>
                </div>
            </div>
        );
    }
    return (
        <div className='app'>
            <main className='page' style={{ paddingTop: 0 }}>
                <section className='section section-about'>
                    <div className='hero'>
                        <img src='/jax_small.jpg' alt='Logo' className='hero-image' />
                        <div className='hero-overlay'>
                            <div className='hero-text-box'>
                                <div className='hero-title-main'>North Florida</div>
                                <div className='hero-title-sub'>Home Repair & Maintenance</div>
                            </div>
                        </div>
                    </div>

                    <div className='custom-quote'>
                        <div className="quote-subsection" style={{ borderBottom: '2px solid #111827' }}>
                            <p>Thank you again for the opportunity to review your project. I've gone through the details and prepared the information below.</p>
<p>As promised, you'll find a breakdown of the quoted work. I've included notes where helpful to provide additional context around certain items.</p>
<p>The scope of work is outlined below. If the project includes multiple components, they are presented separately so you can move forward with any portion at your discretion. When you're ready to proceed, I can provide a formal quote for approval.</p>
                        </div>

                        
            <div key="0" className="project-wrap">
                <h2 className="project-static-title">Project 1: Baseboards, doors, archway, fireplace, window</h2>
                
            <div className="quote-section">
                
                <div className='quote-subsection'>
                    <div className="project-description">
                        These are the items you told me you definitely want done.
                    </div>
                </div>
                <hr />
                
                <div className='quote-subsection'>
                    <h3 className="section-label">Scope of work</h3>
                    <div className="white-card">
                        <ul className="scope-list">
                            <li>Scope item 1</li>
                        </ul>
                        <div className="time-expectation"><strong>Time expectation:</strong> 123 hours</div>
                    </div>
                    
                </div>
                
                <hr />
                <div className='quote-subsection'>
                    <h3 className="section-label">Pricing</h3>
                    <div className="quote-pricing-block">
                        <div className="pricing-row">
                            <span className="pricing-label">Labor (flat rate):</span>
                            <span className="pricing-value">$</span>
                        </div>
                        <div className="pricing-row">
                            <span className="pricing-label">Materials:</span>
                            <span className="pricing-value">$</span>
                        </div>
                        <div className="pricing-row pricing-row--total">
                            <span className="pricing-label">Estimated total:</span>
                            <span className="pricing-value">$</span>
                        </div>
                    </div>
                    
                    <AcceptButton projectName="Baseboards, doors, archway, fireplace, window" />
                </div>
            </div>
        
            </div>

                        <hr style={{ marginTop: '3rem' }} />
                        <h2>Next Steps</h2>
                        <p>
                            Estimates provided are valid for 30 days. For any project that requires a significant material order, 
                            a deposit covering material costs is required prior to scheduling. Labor is due upon completion of the work.
                        </p>
                        <p>
                            <strong>Please reach out</strong> whenever you are ready to move forward or if you have any questions!
                        </p>
                    </div>
                </section>
            </main>
            <footer className="quote-footer">
                <h1>Thank you!</h1>
                <div className="footer-brand-box">
                    <img 
                        src="/transparent-logo-min.png" 
                        alt="North Florida Home Repair & Maintenance" 
                        className="footer-logo" 
                    />
                    <div className="footer-fine-print">
                        Reliable | Insured | Professional Home Services
                    </div>
                </div>
                <div className="footer-contact-info">
                    <a href="tel:9043862663" className="contact-link">
                        (904) 386-2663
                    </a>
                    <span className="contact-divider">•</span>
                    <a href="mailto:daniel@northfloridarepair.com" className="contact-link">
                        daniel@northfloridarepair.com
                    </a>
                </div>
                
                <div className="footer-actions">
                    <button onClick={() => navigate('/')} className='home-button'>
                        ← Return Home
                    </button>
                </div>
            </footer>
        </div>
    );
}

export default Quote_JsusA8ulIfJ9;
    